import {
    FETCH_FAVORITES_REQUEST,
    FETCH_FAVORITES_SUCCESS,
    FETCH_FAVORITES_ERROR,
    TOGGLE_FAVORITE_REQUEST,
    TOGGLE_FAVORITE_SUCCESS,
    TOGGLE_FAVORITE_ERROR,
} from './WishlistPage.actions';

// ================ Reducer ================ //

const initialState = {
    favoriteListingRefs: [],
    fetchFavoritesInProgress: false,
    fetchFavoritesError: null,
    toggleFavoriteInProgress: false,
    toggleFavoriteListingId: null, // Track which listing is being toggled
    toggleFavoriteError: null,
    pagination: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_FAVORITES_REQUEST:
            return {
                ...state,
                fetchFavoritesInProgress: true,
                fetchFavoritesError: null,
            };
        case FETCH_FAVORITES_SUCCESS:
            return {
                ...state,
                favoriteListingRefs: payload.listingRefs,
                fetchFavoritesInProgress: false,
                pagination: payload.pagination,
            };
        case FETCH_FAVORITES_ERROR:
            return {
                ...state,
                fetchFavoritesInProgress: false,
                fetchFavoritesError: payload,
            };
        case TOGGLE_FAVORITE_REQUEST:
            return {
                ...state,
                toggleFavoriteInProgress: true,
                toggleFavoriteListingId: payload.listingId,
                toggleFavoriteError: null,
            };
        case TOGGLE_FAVORITE_SUCCESS: {
            // If removing a favorite, also remove from favoriteListingRefs
            const { listingId, wasRemoved } = payload;
            const updatedRefs = wasRemoved
                ? state.favoriteListingRefs.filter(ref => ref.id.uuid !== listingId)
                : state.favoriteListingRefs;
            return {
                ...state,
                favoriteListingRefs: updatedRefs,
                toggleFavoriteInProgress: false,
                toggleFavoriteListingId: null,
            };
        }
        case TOGGLE_FAVORITE_ERROR:
            return {
                ...state,
                toggleFavoriteInProgress: false,
                toggleFavoriteListingId: null,
                toggleFavoriteError: payload,
            };
        default:
            return state;
    }
}
